<template>
  <div>
    <result-header
      class="my-3"
      :info="resultData.header"
      @on-edit="onEditHandler"
    />
    <create-budget
      v-if="openEditBudget"
      class="mt-3"
      edit-mode
      icon="fas fa-edit"
      :selected-academic-year="budgetSelectedAcademicYear"
      :service-budget-id="budgetId"
      title="Editar Presupuesto"
      @on-cancel="openEditBudget = false"
      @on-save="onSaveBudgetHandler"
    />
    <div
      v-for="(item, index) in resultData.body"
      :key="`search-result-item-${index}`"
      class="mb-3"
    >
      <callout
        :controlled="true"
        :disabled="showDetails(item.serviceName)"
        :has-toggle="true"
        :opened="item.isOpen"
        @click:open="$emit('on-open-details', index)"
      >
        <div class="row">
          <div class="col-md-2 col-sm-12 border-right pr-3">
            <div class="mt-3 text-center">
              <label class="color-black font-16 font-weight-bold">
                {{ item.serviceName }}
              </label>
            </div>
          </div>
          <div class="col-md-10 py-2 px-4">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Pagado:</div>
                <span class="data">{{ emptyValue(item.paid) | price }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Actual:</div>
                <span class="data">{{ emptyValue(item.actual) | price }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Proyectado:</div>
                <span class="data">
                  {{ emptyValue(item.projected) | price }}
                </span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Estudiante:</div>
                <span class="data">{{ item.studentCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <template #edition>
          <div class="bg-gray p-2">
            <div class="bg-white rounded p-3">
              <result-not-found v-if="item.services.length == 0" />
              <div
                v-for="(srvItem, srvIndex) in item.services"
                :key="`srv-item-${srvIndex}`"
                class="mb-3"
              >
                <callout :has-border="false" :has-toggle="false">
                  <div class="row">
                    <div class="col-md-2 col-sm-12 border-right mt-2">
                      <div class="data-label">Tipo de Servicio:</div>
                      <span class="data">{{ srvItem.disciplineType }}</span>
                    </div>
                    <div class="col-md-10 py-2 px-4">
                      <div class="row">
                        <div class="col-md-3 pl-3">
                          <div class="data-label">Pagado:</div>
                          <span class="data">
                            {{ emptyValue(srvItem.paid) | price }}
                          </span>
                        </div>
                        <div class="col-md-3 pl-4">
                          <div class="data-label">Actual:</div>
                          <span class="data">
                            {{ emptyValue(srvItem.actual) | price }}
                          </span>
                        </div>
                        <div class="col-md-3 pl-4">
                          <div class="data-label pl-1">Proyectado:</div>
                          <span class="data pl-1">
                            {{ emptyValue(srvItem.projected) | price }}
                          </span>
                        </div>
                        <div class="col-md-3 pl-4">
                          <div class="data-label pl-2">Estudiantes:</div>
                          <span class="data pl-2">
                            {{ srvItem.studentCount }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </callout>
              </div>
            </div>
          </div>
        </template>
      </callout>
    </div>
  </div>
</template>

<script>
import Callout from '@/shared/components/Callout/View';
import ResultNotFound from '@/components/common/ResultNotFound';
import { ResultHeader } from './components';
import { CreateBudget } from './components';

export default {
  name: 'SearchResult',
  components: {
    Callout,
    ResultNotFound,
    ResultHeader,
    CreateBudget,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({
        header: {},
        body: [],
      }),
    },
  },
  data: () => ({
    openEditBudget: false,
    budgetSelectedAcademicYear: null,
    budgetId: null,
  }),
  computed: {
    showDetails() {
      return (serviceName) => serviceName === 'Otros';
    },
  },
  methods: {
    onEditHandler(item) {
      this.$emit('on-edit', { ...item });
      this.openEditBudget = true;
      this.budgetSelectedAcademicYear = {
        name: item.academicYear,
        id: item.academicYearId,
      };
      this.budgetId = item.serviceBudgetId;
    },
    async onSaveBudgetHandler(model) {
      this.openEditBudget = false;
      this.$emit('on-edit-budget', { ...model });
    },
    emptyValue(value) {
      return value == null || value == '' ? 0.0 : value;
    },
    emptyText(value) {
      return value == null || value == '' ? '--' : value;
    },
  },
};
</script>
